export const NotchLoader = ({
  // text = null,
  size = 35,
  // color = '#2c3e50',
  color = 'var(--tg-theme-text-color)',
  duration = '1.25s',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 100 100"
    >
      <circle
        cx="50"
        cy="50"
        r="45"
        stroke={color}
        strokeWidth="10"
        fill="none"
        strokeDasharray="283"
        strokeDashoffset="75"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          dur={duration}
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  )
}
